export enum ScaleChoices {
    AUTO = "auto",
    FIXED = "fixed",
};